import { IntegrationDetail, Project } from "../redux/slices/projects/Types";

export type DocumentationIds = {
  technologyId: string;
  integrationTypeId: string;
};

export const getDocumentationIds = (
  projectDetails: Project | null | undefined,
  integrationId?: number | string | null,
  integrationDetail?: IntegrationDetail | null
): DocumentationIds | null => {
  const numericIntegrationId = Number(integrationId);
  if (!Number.isFinite(numericIntegrationId) || numericIntegrationId <= 0) {
    return null;
  }

  if (projectDetails?.technologies) {
    for (const technology of projectDetails.technologies) {
      const integration = technology.integrations?.find(
        (item) => item.integration_id === numericIntegrationId
      );
      if (!integration) continue;

      const technologyId = technology.setting_technology_id;
      const integrationTypeId = integration.integration_type_id;
      if (technologyId && integrationTypeId) {
        return {
          technologyId: String(technologyId),
          integrationTypeId: String(integrationTypeId),
        };
      }
    }
  }

  const fallbackTechnologyId = integrationDetail?.setting_technology_id;
  const fallbackIntegrationTypeId = integrationDetail?.integration_type_id;
  if (fallbackTechnologyId && fallbackIntegrationTypeId) {
    return {
      technologyId: String(fallbackTechnologyId),
      integrationTypeId: String(fallbackIntegrationTypeId),
    };
  }

  return null;
};
